import API from './api';

import RawSuscResult from '../../../../models/raw-susc-result';

export async function fetchSuscResults(rawSequenceAlignmentPairs) {
  let patientIsolateNamePairs = {};
  let patientIsolateNameGenes = {};
  let result = [];
  for (const [seq, align] of rawSequenceAlignmentPairs) {
    let {existingPatientId, ptAlias, isolateName,
      mutationGenes, uuid: rawSequenceUUID} = seq;
    const rawAlignmentUUID = align? align.uuid : null;
    if (align && 'geneSequences' in align) {
      mutationGenes = align.geneSequences.map(({gene}) => gene);
    }

    const mapkey = `${existingPatientId || ptAlias}$$${isolateName}`;
    patientIsolateNamePairs[mapkey] = [
      existingPatientId, ptAlias, isolateName, mutationGenes,
      rawSequenceUUID, rawAlignmentUUID];

    patientIsolateNameGenes[mapkey] = patientIsolateNameGenes[mapkey] || [];
    patientIsolateNameGenes[mapkey] = patientIsolateNameGenes[mapkey].concat(
      mutationGenes);
  }

  for (const mapkey of Object.keys(patientIsolateNamePairs)) {
    let mutationGenes = patientIsolateNameGenes[mapkey];
    mutationGenes = new Set(mutationGenes);
    mutationGenes = Array.from(mutationGenes);
    patientIsolateNamePairs[mapkey][3] = mutationGenes;
  }

  // patientIsolateNamePairs = Object.values(patientIsolateNamePairs);
  if (Object.keys(patientIsolateNamePairs).length === 0) {
    return result;
  }
  // const newPatientIsolateNamePairs = patientIsolateNamePairs.filter(([ptid]) => !ptid);
  // patientIsolateNamePairs = patientIsolateNamePairs.filter(([ptid]) => ptid);

  const {viewer: {isolates}} = await API({
    patientIsolateNamePairs: Object.values(patientIsolateNamePairs)
      .filter(([ptid]) => !ptid)
      .map(([patientId,,isolateName]) => ({patientId, isolateName}))
  });

  const existingSuscResults = [];
  if (isolates) {
    for (let {node} of isolates.edges) {
      const {
        patient: {id: existingPatientId, ptAlias},
        isolateName, suscResults
      } = node;
      delete patientIsolateNamePairs[`${existingPatientId}$$${isolateName}`];
      for (const suscResult of suscResults) {
        existingSuscResults.push({
          existingPatientId,
          ptAlias, isolateName,
          ...suscResult
        });
      }
    }
  }

  // create default SUSC result for new strains
  // TODO: get genes from mutation list
  result = Object.values(patientIsolateNamePairs)
    .reduce((acc, [existingPatientId, ptAlias, isolateName, genes,
      rawSequenceUUID, rawAlignmentUUID]) => {
      for (const gene of genes) {
        acc.push(
          new RawSuscResult({existingPatientId, ptAlias, isolateName, gene,
            rawSequenceUUID, rawAlignmentUUID})
        );
      }
      return acc;
    }, []);
  return existingSuscResults.concat(result);
}

export async function fetchDrugNames(rawDataCollection) {
  const {rawSuscResults} = rawDataCollection;

  let allDrugs = new Set();
  for (const suscResult of rawSuscResults) {
    const {drugName} = suscResult;
    if (drugName) {
      allDrugs.add(drugName);
    }
  }
  allDrugs = Array.from(allDrugs);


  const {viewer: {luDrugs}} = await API({
    drugNames: allDrugs
  });


  if (!luDrugs || !luDrugs.edges) {
    return rawDataCollection;
  }
  if (!rawDataCollection.validDrugs) {
    rawDataCollection.validDrugs = {};
  }
  Object.assign(
    rawDataCollection.validDrugs,
    luDrugs.edges.reduce(
      (acc, {node: {drugName, drugClass}}) => {
        acc[drugName] = drugClass;
        return acc;
      }, {}
    )
  );
  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/hivdb/load.js